import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  background: color => ({
    height: '100%',
    paddingVertical: 12,
    backgroundColor: color
  }),
  icon: { marginTop: 0 }
})

export default styles
